import { useContext } from "react";
import { ApiContext } from "../app/providers/ApiProvider";

export const useApi = () => {
  return useContext(ApiContext);
};
